export const RIGHT = 'App/Components/DoubleArrow::RIGHT';
export const LEFT = 'App/Components/DoubleArrow::LEFT';
